import { takeLatest, select, cancel, put } from 'redux-saga/effects';
import size from 'lodash/size';

import * as myProviders from '../requests/my-providers-req';
import { selectMyProvidersCount, selectMyProvidersList } from '../selectors';

function* loadMoreMyProviders({ payload }) {
  const counter = yield select(selectMyProvidersCount);
  const list = yield select(selectMyProvidersList);
  const listSize = size(list);

  if (counter <= listSize) {
    yield cancel();
  }

  yield put(
    myProviders.paginationActions.send({ ...payload, offset: listSize }),
  );
}

export default function* myProvidersListPagination() {
  yield takeLatest([myProviders.consts.LOAD_MORE], loadMoreMyProviders);
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/my-providers-pagination-saga.js